import { useStrings } from "@1js/localization-components";
import {
  Body1,
  Image,
  makeStyles,
  Subtitle1,
  tokens,
} from "@fluentui/react-components";
import React from "react";
import { useNavigate } from "react-router-dom";
import { readFromMetaTags } from "../../../utils/Telemetry/config";
import {
  BrowseMicrosoftPrompts,
  NoWorkplaceResultHeading,
  NoWorkplaceResultHeadingParagraph,
  NoWorkplaceResultSubHeading,
} from "./WorkPlace.strings";

export const useStyles = makeStyles({
  root: {
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "90px",
    gap: "9px",
    width: "100%",
    maxWidth: "536px",
    "@media (max-width: 600px) and (min-width: 361px)": {
      maxWidth: "350px",
    },
    "@media (max-width: 360px)": {
      maxWidth: "250px",
    },
  },
  button: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    width: "256px",
    borderRadius: "4px",
    paddingLeft: "6px",
    paddingRight: "6px",
    paddingTop: "12px",
    paddingBottom: "12px",
    justifyContent: "center",
    cursor: "pointer",
  },
  buttonContainer: {
    paddingTop: "28px",
    textAlign: "center",
  },
});

export const NoWorkPlacePromptResults: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const localizations = useStrings({
    NoWorkplaceResultSubHeading,
    NoWorkplaceResultHeading,
    BrowseMicrosoftPrompts,
    NoWorkplaceResultHeadingParagraph,
  });

  const handleClick = () => {
    navigate(
      `../microsoft?hostName=${readFromMetaTags("awa-hostName")}&hostClientType=${readFromMetaTags("awa-hostClientType")}`
    );
  };

  return (
    <div className={styles.root}>
      <Image
        src="https://copilot.cloud-dev.microsoft/images/0175-search-questionmark-d-standard-128x128.webp" // TODO: once prod deployment is done, update the image URL
        aria-labelledby="no-results-heading"
      />
      <Subtitle1 id="no-results-heading">
        {localizations.NoWorkplaceResultHeading()}
      </Subtitle1>
      <Body1>
        {localizations.NoWorkplaceResultSubHeading()}
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={handleClick}>
            {localizations.BrowseMicrosoftPrompts()}
          </button>
        </div>
      </Body1>
    </div>
  );
};
